import {Question} from '../shared/question';
import {Response} from '../shared/response';

export class OneToOneSegment2Sob{

    question1:Question;
    question2:Question;
    question3:Question;

    questions: Array<Question>;


    constructor(){
        this.question1 = new Question(1, [], 
            'Care este motivul pentru care nu ai accesat sectiunea “Contul meu”, din platforma Sobranie “Your Society”?',
            'In cursul lunii septembrie, ai primit din partea Sobranie un pachet gratuit, pe care l-ai revendicat din magazin. Pentru a intra in posesia pachetului, ai folosit un cod de revendicare, disponibil, in prima faza, in sectiunea “Contul meu”, de pe platforma Sobranie “Your Society”. Ulterior, codul ti-a fost trimis prin SMS.',
            'checkbox-free',
            [new Response(1, 'Nu cunosc platforma Your Society'), 
            new Response(2, 'Nu doresc sa am cont in platforma Your Society'),
            new Response(3, 'Nu am inteles pasii necesari pentru activarea contului / ce am de facut – vreau sa ma sune cineva si sa-mi ofere asistenta'),
            new Response(4, 'Nu am inteles pasii necesari pentru activarea contului / ce am de facut – nu vreau sa fiu sunat, ma descurc singur pe viitor'),
            new Response(5, 'Mi s-a parut prea complicat procesul'),
            new Response(6, 'Altele'),
            ],
            false
        );
        
        this.question2 = new Question(2, [],
            'Participi in campanii promotionale, in general, indiferent de categorie sau produs?',
            '',
            'radio',
            [new Response(1, 'Da'), 
            new Response(2, 'Nu')
            ],
            false
        );

        this.question3 = new Question(3, [2],
            'Exista un factor care te-ar face sa te razgandesti? Daca da, care?',
            '',
            'checkbox-free',
            [new Response(1, 'Nu'),
            new Response(2, 'Da')
            ],
            true
        );
        this.question3.render = ()=>{
            let question2SelectedIds = this.getSelectedAnswersIds(this.question2);
            return question2SelectedIds.length > 0 && question2SelectedIds.indexOf(2)>=0;
        }

        

        this.questions = [this.question1, this.question2, this.question3];
    }

    
    getQuestions():Array<Question>{
        return this.questions;
    }

    getSelectedAnswersIds(question:Question):Array<Number>{
        return question.responses.filter(r => r.selected).map(r => r.id);
    } 
    
}

